module.exports = __webpack_public_path__ + "static/youtube_social_circle_white-540020877db348ff44d73e9deadf58d9.png";